export default __webpack_public_path__ + "static/media/Img3@2x.8254d022.jpg";